/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OIDCChallengeOptions } from './OIDCChallengeOptions';
import {
    OIDCChallengeOptionsFromJSON,
    OIDCChallengeOptionsFromJSONTyped,
    OIDCChallengeOptionsToJSON,
    OIDCChallengeOptionsToJSONTyped,
} from './OIDCChallengeOptions';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface OIDCChallenge
 */
export interface OIDCChallenge {
    /**
     * 
     * @type {string}
     * @memberof OIDCChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof OIDCChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof OIDCChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {OIDCChallengeOptions}
     * @memberof OIDCChallenge
     */
    options: OIDCChallengeOptions;
}



/**
 * Check if a given object implements the OIDCChallenge interface.
 */
export function instanceOfOIDCChallenge(value: object): value is OIDCChallenge {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}

export function OIDCChallengeFromJSON(json: any): OIDCChallenge {
    return OIDCChallengeFromJSONTyped(json, false);
}

export function OIDCChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OIDCChallenge {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': OIDCChallengeOptionsFromJSON(json['options']),
    };
}

export function OIDCChallengeToJSON(json: any): OIDCChallenge {
    return OIDCChallengeToJSONTyped(json, false);
}

export function OIDCChallengeToJSONTyped(value?: OIDCChallenge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ChallengeTypeToJSON(value['type']),
        'authentication_method': FactorMethodToJSON(value['authentication_method']),
        'options': OIDCChallengeOptionsToJSON(value['options']),
    };
}

